
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminal/download",
      function () {
        return require("private-next-pages/terminal/download/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminal/download"])
      });
    }
  